import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FileInput, Warning } from '../../../../../utils/models/input.interface';
import { returnColorWarning, returnTextWarning, returnWarningIcon } from '../../../functions/utilities.service';

@Component({
  selector: 'file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FileInputComponent,
    },
  ],
})

export class FileInputComponent implements OnInit, ControlValueAccessor {
  warningIconFileInput = returnWarningIcon;
  colorWarningFileInput = returnColorWarning;
  textWarningFileInput = returnTextWarning;

  @Input() fileInput: FileInput;

  @Input() warning: Warning = {
    sucess: null,
    error: null,
    info: null,
    alert: null,
    load: null
  };


  @Output() fileImport: EventEmitter<any> = new EventEmitter<any>()
  file: any = null;
  isInvalidType = false;
  acceptedTypes = '';
  textPlaceHolder = 'Selecione ou arraste o arquivo';

  constructor(private readonly toastr: ToastrService) { }

  ngOnInit(): void {
    this.setAcceptedTypes();
  }

  writeValue(value: any): void {
    this.fileInput.value = value;
  }

  onChange = (value: any) => {
    return value;
  };

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(onChange: (value: any) => any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  selectFile(event): void {
    const objFile = event[0] || event?.target?.files[0];
    if (this.checkFileType(objFile?.name)) {
      this.file = objFile;
      this.onChange(this.file)
      this.fileImport.emit(this.file);
      this.isInvalidType = false;
    } else {
      this.isInvalidType = true;
      this.file = null;
      this.toastr.show('Arquivo Inválido.', 'Erro', { timeOut: 5000, messageClass: 'error' });
    }
  }

  checkFileType(name) {
    const nameAux = name.split('.');
    return this.fileInput.types.includes(nameAux[nameAux.length - 1]);
  }

  setAcceptedTypes() {
    if (this.fileInput?.types?.length > 1) {
      this.acceptedTypes = this.fileInput?.types?.map(type => `.${type},`).join(' ');
    } else {
      this.acceptedTypes = `.${this.fileInput?.types[0]}`;
    }
  }
}
